<template>
  <div class="fourElements">
    <div class="fourElementsContainer">
      <div class="oh fl  mr20">
        <div class="fl lh30">站点：</div>
        <div class="fl">
          <a-select
            allowClear
            max-tag-count="responsive"
            ref="select"
            mode="multiple"
            v-model:value="searchParams.siteIds"
            style="width: 180px"
            @change="searchList"
          >
            <a-select-option
              :value="item.id"
              :key="key"
              v-for="(item, key) in sites"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </div>
      </div>
      <div class="oh fl mr20">
        <div class="fl lh30">终端：</div>
        <div class="fl">
          <a-select
            allowClear
            max-tag-count="responsive"
            ref="select"
            mode="multiple"
            v-model:value="searchParams.terminalIds"
            style="width: 100px"
            @change="searchList"
          >
            <a-select-option :value="1" key="web">WEB</a-select-option>
            <a-select-option :value="2" key="app">APP</a-select-option>
          </a-select>
        </div>
      </div>
      <div class="oh fl mr20">
        <div class="fl lh30">位置：</div>
        <div class="fl">
          <a-select
            allowClear
            max-tag-count="responsive"
            ref="select"
            v-model:value="searchParams.moduleType"
            style="width: 200px"
            @change="searchList"
          >
            <a-select-option value="1" key="web">Buy It With</a-select-option>
            <a-select-option value="2" key="app"
              >You May Also Like</a-select-option
            >
            <a-select-option value="3" key="app">Similar Items</a-select-option>
          </a-select>
        </div>
      </div>
      <div class="oh fl mr20">
        <a-button type="primary" @click="exportVisible = true">导入</a-button>
      </div>
      <div class="oh fl mr20">
        <a-popover
          title=""
          trigger="click"
          v-model:visible="batchSearchVisible"
        >
          <template #content>
            <div>
              <a-textarea
                allowClear
                v-model:value="searchParams.mainSkcs"
                placeholder="批量输入，以英文逗号或回车隔开"
                :rows="4"
              />
            </div>
            <div style="margin-top: 10px;text-align: right">
              <a-space>
                <a-button
                  size="small"
                  type="default"
                  @click="
                    () => {
                      batchSearchVisible = false
                    }
                  "
                  >取消</a-button
                >
                <a-button size="small" type="primary" @click="batchSearch"
                  >查询</a-button
                >
              </a-space>
            </div>
          </template>
          <a-button type="primary">批量查询</a-button>
        </a-popover>
      </div>
    </div>
    <div class="tar">
      <a-button type="primary" @click="() => changeVisible(null)"
        >新增</a-button
      >
    </div>
  </div>
</template>
<script>
import { inject, toRefs } from 'vue'
export default {
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>
<style scoped>
.fourElements {
  background: #ffffff;
  padding: 10px 20px 20px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.fourElementsContainer {
  display: flex;
  flex-direction: row;
}
.ant-popover-message-title {
  margin-left: 0;
}
</style>
